import {connect} from 'react-redux';
import {ActionsRow, Loader, PageContent, ScrollableCard, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {withRouter} from "react-router";
import * as opravneniActions from "../actions/opravneniActions";
import * as objednavkaActions from "../actions/objednavkaActions";
import {CardBody, Col, Row} from "reactstrap";
import {formatDate, getIdFromProps} from "../utils/utils";
import ZakladniInformacePanel from "../components/ZakladniInformacePanel";
import KontaktniInformacePanel from "../components/KontaktniInformacePanel";
import ParametryObjednavkyPanel from "../components/ParametryObjednavkyPanel";
import DopravaPlatbaPanel from "../components/DopravaPlatbaPanel";
import FakturacniPolozkyPanel from "../components/FakturacniPolozkyPanel";
import PrilozeneSouboryPanel from "../components/PrilozeneSouboryPanel";
import HistorieZmenPanel from "../components/HistorieZmenPanel";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import Title from "../components/Title";
import {withTranslation, WithTranslation} from "react-i18next";

const {storeFromArea} = utils;

/**
 * Stránka s detailem objednávky.
 */
class ObjednavkaPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(objednavkaActions.fetchObjednavkaIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(objednavkaActions.fetchObjednavkaRightsIfNeeded(getIdFromProps(this.props)));
    };

    handleOtevritSoubor = (soubor) => {
        window.open(`${serverContextPath}/api/cgo/objednavka/${getIdFromProps(this.props)}/soubor/${soubor.idDokumentSoubor}`);
    };

    handleStahnoutSoubory = () => {
        window.open(`${serverContextPath}/api/cgo/objednavka/${getIdFromProps(this.props)}/soubory`);
    };

    renderHeader = (objednavka) => {
        const {objednavkaRights, t} = this.props;
        const canSeeCena = objednavkaRights.data.viewObjCena;
        return <CardBody>
            <ActionsRow className="my-2">
                <h1 className="mb-0">{`${t('order.price_date_and_number', {date: formatDate(objednavka.datumZapis), orderNumber: objednavka.cisloObjednavka})}${objednavka.celkemSDph && canSeeCena ? t('order.price_per_order', {priceIncludingVat: objednavka.celkemSDph}) : ""}`}</h1>
            </ActionsRow>
        </CardBody>
    };

    render() {
        const {objednavkaDetail, objednavkaRights, loggedInUser, t} = this.props;

        if (!objednavkaDetail.fetched || objednavkaDetail.isFetching || !objednavkaRights.fetched || objednavkaRights.isFetching || !loggedInUser.fetched || loggedInUser.isFetching) {
            return <Loader/>;
        }

        const objednavka = objednavkaDetail.data;
        const uzivatel = loggedInUser.data;
        const rights = objednavkaRights.data;

        const canSeeFakturacniPolozky = uzivatel.role === EnumRole.OPERATOR || uzivatel.role === EnumRole.ADMIN;
        const canSeeHistorieZmen = uzivatel.role === EnumRole.OPERATOR || uzivatel.role === EnumRole.ADMIN;

        return <Title title={t('order.order_name_interactive', {orderNumber: objednavka.cisloObjednavka})}>
            <PageContent fullWidth header={this.renderHeader(objednavka)}>
                <ScrollableCard detail>
                    <Row className="w-100 mt-3 mr-1">
                        <Col xs={12} md={6}>
                            <Row>
                                <Col xs={12}>
                                    <ZakladniInformacePanel objednavka={objednavka} objednavkaRights={objednavkaRights.data}/>
                                </Col>
                                <Col xs={12}>
                                    <ParametryObjednavkyPanel objednavka={objednavka} readOnly={!uzivatel.rgObjednavEditSprava || !rights.editObjParametry}/>
                                </Col>
                                {canSeeFakturacniPolozky && <Col xs={12}>
                                    <FakturacniPolozkyPanel
                                        objednavka={objednavka}
                                        objednavkaRights={rights}
                                        readOnly={!uzivatel.rgObjednavEditSprava || !rights.editObjPolozky}
                                    />
                                </Col>}
                            </Row>
                        </Col>
                        <Col xs={12} md={6}>
                            <Row>
                                <Col xs={12}>
                                    <KontaktniInformacePanel objednavka={objednavka} readOnly={!uzivatel.rgObjednavEditSprava || !rights.editObjKontakt}/>
                                </Col>
                                <Col xs={12}>
                                    <DopravaPlatbaPanel objednavka={objednavka} />
                                </Col>
                                <Col xs={12}>
                                    <PrilozeneSouboryPanel
                                        souboryList={objednavka.objednavkaSouborList}
                                        onClick={this.handleOtevritSoubor}
                                        onStahnoutVse={this.handleStahnoutSoubory}
                                    />
                                </Col>
                                {canSeeHistorieZmen && <Col xs={12}>
                                    <HistorieZmenPanel objednavkaZmenaList={objednavka.objednavkaZmenaList}/>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </ScrollableCard>
            </PageContent>
        </Title>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        objednavkaDetail: storeFromArea(state, objednavkaActions.OBJEDNAVKA_DETAIL_AREA),
        objednavkaRights: storeFromArea(state, objednavkaActions.OBJEDNAVKA_RIGHTS_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ObjednavkaPage)));

